"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = __importDefault(require("./request"));
const empty_result_1 = __importDefault(require("../common/empty_result"));
class StorableResult {
    constructor(result) {
        this.result = result;
    }
    call(apiKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const [type] = this.result.id.split(".");
            const request = new request_1.default({ access_token: apiKey, types: type, limit: "1" });
            const term = [this.result.longitude, this.result.latitude].join(",");
            const response = yield request.permanent(term);
            if (!response) {
                return new empty_result_1.default(this.result.name);
            }
            return response;
        });
    }
}
exports.default = StorableResult;
